import React from 'react';
import Index from "./components/Index";
import "./assets/scss/theme.scss";
import "bootstrap-icons/font/bootstrap-icons.css";

const App = () => {
  return (
    <div className="App"> 
      <Index />
    </div>
  );
};

export default App;
